import React from 'react';
import entityTypes from 'js/enums/entity-types.enum';
import ReportTypeRadio from './report-type-radio';

export default function ReportTypeStep({ template, onChangeType }) {
    const reportTypeOptions = [
        {
            label: 'Display Insights',
            value: entityTypes.DISPLAY_REPORTS,
        },
        {
            label: 'Video Insights',
            value: entityTypes.VIDEO_REPORTS,
        },
        {
            label: 'Event Log',
            value: entityTypes.EVENT_LOG_REPORTS,
        },
    ];

    return (
        <ReportTypeRadio
            label="Report Type"
            options={reportTypeOptions}
            selectedValue={template.type}
            onChange={(type) => onChangeType(type)}
        />
    );
}
